<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Visualizar e Enviar Avisos'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/detalhes-da-empresa/' + this.$route.params.idCompany + '/' + this.$route.params.context"
                   :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <label>Texto</label>
                    <vue-editor id="editor" useCustomImageHandler v-model="dataSend.text"/>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="checkbox inline-block">
                      <input v-model="dataSend.sentEmail" id="sentEmail" type="checkbox">
                      <label v-on:click="dataSend.sentEmail = !dataSend.sentEmail">
                        Enviar email?
                      </label>
                    </div>

                    <div class="checkbox inline-block">
                      <input v-model="dataSend.beNotifiedWhenRead" id="beNotifiedWhenRead" type="checkbox">
                      <label v-on:click="dataSend.beNotifiedWhenRead = !dataSend.beNotifiedWhenRead">
                        Notificar quando a mensagem for lida?
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="registerNotification()">Cadastrar</button>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de notificação ({{
                        listFromNotifications.length
                      }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table-elements table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> Empresa</th>
                        <th> Texto</th>
                        <th> Lido?</th>
                        <th> Enviado</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="n in listFromNotifications">
                        <td>{{ n.companyName }}</td>
                        <td v-html="n.text"></td>
                        <td>
                          <span v-if="n.isRead">Lido</span>
                          <span v-else>Pendente</span>
                        </td>
                        <td>{{ n.createdAt | formatFullDateS }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  GET_NOTIFICATIONS,
  CREATE_NOTIFICATIONS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  VueEditor,
  Quill
} from "vue2-editor";

export default {
  name: "company-notification",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    VueEditor,
    Quill
  },
  data() {
    return {
      dataSend: {
        text: '',
        beNotifiedWhenRead: false,
        sentEmail: false,
      },
      loading: false,
      failRequest: false,
      listFromNotifications: []
    }
  },
  methods: {
    registerNotification() {
      this.failRequest = false;
      this.loading = true;
      this.dataSend.companyId = this.$route.params.idCompany;

      REQUEST_SERVICE.requestContext('POST', CREATE_NOTIFICATIONS, this.$route.params.context, this.dataSend).then((response) => {
        UTIL_SERVICE.console("RESULT CREATE_NOTIFICATIONS:", response.data);

        this.dataSend.text = null;
        this.dataSend.beNotifiedWhenRead = false;
        this.dataSend.sentEmail = false;
        this.getNotifications();
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    getNotifications() {
      this.loading = true;
      let url = GET_NOTIFICATIONS + "?i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext('GET', url, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_NOTIFICATIONS:", response.data);

        this.listFromNotifications = response.data;
        this.loading = false;
      }).catch((reason) => {
        this.loading = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.getNotifications();
  }
}
</script>

<style lang="scss">
.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837d7d;
    border-bottom: 1px solid #bdb3b3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598dc;
    color: #ffffff;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}

.checkbox {
  text-align: left;
  margin-left: 30px;
}

.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-top: 2px;
  padding-left: 5px;
  top: 0 !important;
}

.checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 1px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #cccccc;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox label::after {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  top: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 2px;
  font-size: 14px;
  color: #3598dc;
}

.checkbox input[type="checkbox"] {
  opacity: 0;
  z-index: 1;
  height: 20px;
  width: 20px;
}

.checkbox input[type="checkbox"]:focus + label::before {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.checkbox input[type="checkbox"]:checked + label::after {
  font-family: "FontAwesome", serif;
  content: "\f00c";
}

.checkbox input[type="checkbox"]:disabled + label {
  opacity: 0.65;
}

.checkbox input[type="checkbox"]:disabled + label::before {
  background-color: #eeeeee;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox-info input[type="checkbox"]:checked + label::before {
  background-color: #FFF;
  border-color: #01A0DD;
}

.checkbox-info input[type="checkbox"]:checked + label::after {
  color: #01A0DD;
}

.table-elements {
  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/companyNotification.vue